export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-xl font-bold text-background-50">韩漫</span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              韩漫漫画网址导航与在线观看汇总平台，汇集韩漫网站、韩漫网、韩漫之家、韩漫屋等热门韩漫平台入口，提供免费韩漫网址在线观看导航服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '专题索引', href: '#index' },
                { label: '热门推荐', href: '#cards' },
                { label: '人气榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
                { label: '更新动态', href: '#updates' },
                { label: '平台特色', href: '#features' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门入口
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '韩漫之家', href: '#cards' },
                { label: '韩漫屋', href: '#cards' },
                { label: '韩漫网', href: '#cards' },
                { label: '韩漫吧', href: '#cards' },
                { label: '韩漫在线', href: '#cards' },
                { label: '韩漫网址大全', href: '#index' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴信息持续更新中，欢迎优质韩漫平台与我们建立合作。
            </p>
            <div className="mt-4">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-1.5 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
              >
                <i className="ri-mail-add-line"></i>
                申请合作
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            © 2020-2026 韩漫导航. 本站仅提供韩漫网站导航入口，不存储任何漫画内容。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>韩漫网站导航</span>
            <span>韩漫漫画网站大全</span>
            <span>免费韩漫网址</span>
          </div>
        </div>
      </div>
    </footer>
  );
}